export function documentsList() {

    const showDocumentsList = document.querySelector('.js-showDocumentsList');
    const documentsList = document.querySelector('.js-documentsList');

    if (!showDocumentsList) {
        return false;
    }

    showDocumentsList.addEventListener('click', () => {
        documentsList.classList.add('is-active');
        showDocumentsList.style.display = 'none';
    });
}